window.addEventListener("load", function () {
  const slimSelectSelectors = document.querySelectorAll(".slimselect");
  if (slimSelectSelectors) {
    slimSelectSelectors.forEach(slimSelect => {
      new SlimSelect({
        select: slimSelect,
        showSearch: true,
      });
    });
  }
});
